import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { CampaniasGlobalService } from '../../../services/global-campanias.service';
import { EnumSiNoTodos, FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { catchError, of, tap } from 'rxjs';
import { TwSolicitudCamViewModelBase, equalObjects } from '../../../types/solicitudcam-datosbasicos.types';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { NavMenuService } from 'src/app/components/core/components/navmenu/navmenu.service';
import { UnidadInspeccionService } from '../../unidad-inspeccion.service';
import { Mixin } from 'ts-mixer';
import { CampaniaBase } from '../../../types/campaniaBase';
import { CampaniasService } from 'src/app/components/core/_infrastructure/classes/services/campanias-global.service';
import { PeriodoCamItemViewModel, PeriodoCamViewModel } from 'src/app/components/_mantenimiento/campanias/periodos/datosbasicos/periodocam.types';
import { PeriodoDatosCaCamViewModel, CASelectedViewModel } from '../../../buscadores/solicitudes/buscador-solicitud-cam.types';
import { BuscadorUnidadInspeccionService } from '../../../buscadores/unidades-inspeccion/buscador-unidad-inspeccion.service';
import {
    RecintoUnidadInspeccionItemResultsViewModel,
    FilterSearchingRecintoUnidadInspeccion,
    RecintoUnidadInspeccionItemViewModel,
} from '../../../buscadores/unidades-inspeccion/buscador-unidad-inspeccion.types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ForeignKeyValidator } from 'src/app/components/core/_infrastructure/classes/foreignKeyValidator';
import {
    EnumDescripcionTcTipoSolicitudCamPlural,
    EnumDescripcionTcTipoSolicitudCamSingular,
    EnumIdsTcEstadoUnidadInspeccion,
    EnumIdsTcTipoSolicitudCam,
} from '../../../types/enum';
import {
    TwRecintoUnidadInspeccionViewModel,
    TwUnidadInspeccionViewModel,
    TwUnidadInspeccionViewModelExtended,
} from '../../unidad-inspeccion-datosbasicos.types';
import { PeriodoCamService } from 'src/app/components/_mantenimiento/campanias/periodos/datosbasicos/periodocam.service';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';

@Component({
    selector: 'app-selector-unidad-inspeccion-wrapper',
    templateUrl: './selector-unidad-inspeccion-wrapper.component.html',
    styleUrls: ['./selector-unidad-inspeccion-wrapper.component.scss'],
})
export class SelectorUnidadInspeccionWrapperComponent extends Mixin(ComponentBase, CampaniaBase) implements OnInit, OnDestroy {
    editMode = false;

    /********************************************************************************************************************************
     * Este componente permite tanto:
     * - la creación de UIs a partir de la selección de recintos PI
     * - como añadir un recinto PI a una UI existente. En éste caso se invocaría desde el componente de datos básicos de la UI <app-unidad-inspeccion-wrapper>
     * En éste componente se permite buscar una serie de recintos/cultivos disponibles (sin asignar) para la UI y su incorporación a la misma.
     * No se permite crear UIs de tipos almacén (o emp. deshidratadoras), ni añadir almacenes (o emp. desh.) a una UI existente.
     * Se controlará que las HAs de los cultivos seleccionados para la UI, no supere el tamaño máximo de agrupación (ha) establecido en el periodo vinculado a la UI.
     *******************************************************************************************************************************/
    visibilitySpinnerSave = false;
    searching = false;
    result: RecintoUnidadInspeccionItemResultsViewModel | null;
    previousPayload?: FilterSearchingRecintoUnidadInspeccion; // Cuando nos vayamos del componente, restauramos en el servicio de consulta, el último payload usado.
    payload?: FilterSearchingRecintoUnidadInspeccion;

    campanias: Tc[] = [];
    periodos: PeriodoCamItemViewModel[] = [];
    tiposSolicitudPI: Tc[] = [];
    CAs: PeriodoDatosCaCamViewModel[] = [];
    EAs: Tc[] = [];
    operadores: Tc[];
    formGroup: FormGroup;

    // Recinto Detail view params
    recintoDetailVisible = false;
    IdRecintoSelected: number | null;

    unidadInspeccionPayload: TwUnidadInspeccionViewModel;
    unidadInspeccion: TwUnidadInspeccionViewModelExtended;
    periodoForUi: PeriodoCamViewModel | null;

    private WarningMessageRecintosDuplicados = 'Algunos de los Recintos seleccionados ya estaban asociados a la U.I.';
    private successMessage = 'Unidad de Inspección creada correctamente';
    private errorSuperficieSuperadaMessage = 'La superficie acumulada por los cultivos seleccionados, superaría la superficie disponible para la U.I.: ';

    private listUrl = '/campanias/unidadesinspeccion';
    private numberOfChanges = 0;
    private totalHectareasAcumuladas = 0;
    private recintosUIOriginales: RecintoUnidadInspeccionItemViewModel[] = [];
    recintoUnidadInspeccionList: RecintoUnidadInspeccionItemViewModel[];

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const idUi: any = params.get('idUi');
        if (idUi) {
            // Modo edición de UI
            this.editMode = true;
            this.getUnidadInspeccion(idUi);
        } else {
            // Modo creación de UI
            this.unidadInspeccion = new TwUnidadInspeccionViewModelExtended();
            this.recintoUnidadInspeccionList = [];
        }
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        protected globalService: GlobalService, // No borrar ya que se necesita en ComponentBase
        private globalCampaniasService: CampaniasGlobalService,
        protected campaniasService: CampaniasService,
        private buscadorUnidadInspeccionService: BuscadorUnidadInspeccionService,
        private periodoCamService: PeriodoCamService,
        private unidadInspeccionService: UnidadInspeccionService,
        private navMenuService: NavMenuService,
        private router: Router,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.buildForm();
        this.recoverLastSearch();
        this.loadListsForFilters();
    }

    /**
     * Se cargan los datos de la unidad de inspección y sus recintos PI asociados
     * Una vez obtenida, establece el valor para la propiedad readonly a partir de la información del usuario y los permisos de edición.
     * Después invoca al servicio de obtención de recintos de la unidad de inspección.
     * @param id number
     */
    private getUnidadInspeccion(id: number): void {
        this.unidadInspeccionService
            .getUI(id)
            .pipe(
                tap((udInspeccion: TwUnidadInspeccionViewModelExtended) => {
                    // Una UI existente, deberá tener al menos un recinto.
                    // No debería pasar por aquí, porque cuando se eliminan todos los recintos PI de una UI, se elimina además la UI
                    if (!udInspeccion?.FirstRecinto) {
                        console.error('UI sin recintos/cultivos');
                        return;
                    }

                    this.unidadInspeccion = udInspeccion;
                    this.getRecintosUiByIdUi(this.unidadInspeccion.IdUi!);
                    this.getPeriodoInfo(this.unidadInspeccion?.FirstRecinto?.IdPeriodo); // A partir del periodo obtenemos el TamanioMaximoAgrupacion y la SuperficieMax.
                    this.navMenuService.updateMenuServiceForUdInspeccion(
                        udInspeccion.IdUi!,
                        udInspeccion.IdEstadoUi!,
                        udInspeccion.FirstRecinto.IdTipoSolicitudCam || 0,
                        udInspeccion.PeriodoCertificaKgs,
                    );
                    this.updateForm(this.unidadInspeccion?.FirstRecinto);
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.formGroup.disable();
                    return of(null);
                }),
            )
            .subscribe();
    }

    private getRecintosUiByIdUi(idUi: number): void {
        this.unidadInspeccionService
            .getRecintosUiByIdUi(idUi)
            .pipe(
                tap(res => {
                    this.recintosUIOriginales = res;
                    this.recintoUnidadInspeccionList = [...this.recintosUIOriginales];
                    this.calcularHectareasAcumuladas();
                }),
            )
            .subscribe();
    }

    /**
     * Cargamos los datos del periodo para saber cuál es el tamaño máximo de agrupación, en caso que esté así configurado.
     * @param IdPeriodo number
     * @returns void
     */
    private getPeriodoInfo(IdPeriodo: number | undefined): void {
        if (!IdPeriodo) {
            return;
        }
        this.getTiposSolicitudCam(); // Construimos de nuevo la lista de tipos de solicitud inicial.
        this.periodoCamService
            .getById(IdPeriodo)
            .pipe(
                tap((periodo: PeriodoCamViewModel) => {
                    this.periodoForUi = periodo;
                    if (this.periodoForUi?.TPeriodoTipoSolicitudCamCollection?.length > 0) {
                        // Filtramos los tipos de solicitud por los configurados para el periodo
                        let tiposConfigurados: number[] = [];
                        this.periodoForUi.TPeriodoTipoSolicitudCamCollection.forEach(periodoTipo => {
                            tiposConfigurados.push(periodoTipo.IdTipoSolicitud);
                        });
                        this.tiposSolicitudPI = [...this.tiposSolicitudPI.filter(tipo => tiposConfigurados.indexOf(tipo.Id) != -1)];
                    }
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch() {
        this.previousPayload = this.buscadorUnidadInspeccionService.getLastSearch();
    }

    private buildForm(): void {
        const validationForOperador = this.isOperadorCam ? [] : Validators.compose([Validators.required, ForeignKeyValidator.cannotBeNullOrZero]);

        this.formGroup = this.fb.group({
            IdCampania: [{ value: null, disabled: this.editMode }, Validators.compose([Validators.required, ForeignKeyValidator.cannotBeNullOrZero])],
            IdPeriodo: [{ value: null, disabled: this.editMode }, Validators.compose([Validators.required, ForeignKeyValidator.cannotBeNullOrZero])],
            IdCA: [{ value: null, disabled: this.editMode }, Validators.compose([Validators.required, ForeignKeyValidator.cannotBeNullOrZero])],
            IdEntidadAuditora: [{ value: EnumSiNoTodos.TODOS, disabled: this.editMode }],
            CodigoUhc: [{ value: null, disabled: true }], // readonly
            IdTipoSolicitudCam: [{ value: null, disabled: this.editMode }, Validators.compose([Validators.required, ForeignKeyValidator.cannotBeNullOrZero])], // Tipo de recinto
            IdOperador: [{ value: null, disabled: this.editMode }, validationForOperador],
            FechaDesdePresentacion: null,
            FechaHastaPresentacion: null,
            IdProvincia: null,
            IdMunicipio: null,
            Agregado: null, // NOT VISIBLE. Por ahora no se necesita
            Zona: null, // NOT VISIBLE. Por ahora no se necesita
            Poligono: null,
            Parcela: null,
            Recinto: null,
            // NOT VISIBLE
            IdEstadoUnidadInspeccion: [{ value: EnumIdsTcEstadoUnidadInspeccion.ID_SIN_ASIGNAR, disabled: true }], // NOT VISIBLE
            Activa: [{ value: EnumSiNoTodos.SI, disabled: true }],
            IdUsuario: null, // Este valor se establece en el core

            // Los siguientes campos se utilizan solamente en el componente unidad-inspeccion-header. Serán eliminados del payload.
            Campania: [null],
            Periodo: [null],
            DescripcionComunidad: [null],
            EntidadAuditora: [null],
            TipoRecinto: [null], // Tipo de Solicitud
        });
        this.form = this.formGroup;
        this.unidadInspeccionPayload = new TwUnidadInspeccionViewModel();
        this.unidadInspeccionPayload.RecintoUnidadInspeccionListIds = [];
        this.recintosUIOriginales = [];
        this.totalHectareasAcumuladas = 0;
    }

    private updateForm(firstRecinto: TwRecintoUnidadInspeccionViewModel): void {
        this.formGroup.patchValue({
            IdCampania: firstRecinto?.IdCampania || null,
            IdPeriodo: firstRecinto?.IdPeriodo || null,
            IdCA: firstRecinto?.IdCa || null,
            IdEntidadAuditora: firstRecinto?.IdEntidadAuditora || null,
            IdOperador: firstRecinto?.IdOperador || null,
        });
    }

    private loadListsForFilters(): void {
        this.getTiposSolicitudCam();
        const cleanDependent = false;
        this.onActivaSelected(cleanDependent);
    }

    private getTiposSolicitudCam(): void {
        /*
        this.globalService.getTipoSolicitudCam().subscribe(res => {
            // @author: scalero1 - No se permite crear unidades de inspección de tipo almacén (códigos de confección), ni de tipo 'Empresas Deshidratadoras'
            this.tiposSolicitudPI = res?.filter(
                x => x.Id !== EnumIdsTcTipoSolicitudCam.ID_CONFECCION && x.Id !== EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION,
            );
        });
        */
        const tcParcela = new Tc();
        tcParcela.Id = EnumIdsTcTipoSolicitudCam.ID_PARCELA;
        tcParcela.Descripcion = EnumDescripcionTcTipoSolicitudCamSingular.PARCELA;

        const tcInvernadero = new Tc();
        tcInvernadero.Id = EnumIdsTcTipoSolicitudCam.ID_INVERNADERO;
        tcInvernadero.Descripcion = EnumDescripcionTcTipoSolicitudCamSingular.INVERNADERO;
        this.tiposSolicitudPI = [tcParcela, tcInvernadero];
    }

    onActivaSelected(cleanDependent: boolean): void {
        if (cleanDependent) {
            this.cleanDependentOnActiva();
        }
        this.loadDependentOnActiva();
    }

    private loadDependentOnActiva() {
        this.getCampanias();
        this.onCampaniaSelected(this.payload?.IdCampania);
        this.onPeriodoSelected(this.payload?.IdPeriodo);
        const caSelected = new CASelectedViewModel();
        caSelected.idCA = this.payload?.IdCA;
        caSelected.idPeriodo = this.payload?.IdPeriodo;
        this.onCASelected(caSelected);
    }

    private getCampanias(): void {
        this.campanias = [];
        const habilitados = EnumSiNoTodos.SI;
        this.globalCampaniasService.getCampaniasEnPeriodo(habilitados).subscribe(res => {
            this.campanias = [...res];
        });
    }

    onCampaniaSelected(idCampania?: number): void {
        this.getPeriodos(idCampania);
    }

    private getPeriodos(idCampania?: number): void {
        this.periodos = [];
        this.periodoForUi = null;
        this.onPeriodoSelected(this.payload?.IdPeriodo || 0);
        if (!idCampania) {
            return;
        }
        // Además, traerá los que tengan el parámetro HabilitadosTemporalmente a true o el periodo vigente (fecha actual entre FechaInicio y FechaFin)
        this.globalCampaniasService.getPeriodosPIHabilitados(idCampania).subscribe(res => {
            this.periodos = [...res];
        });
    }

    onPeriodoSelected(idPeriodo?: number): void {
        this.getPeriodoInfo(idPeriodo);
        this.getCAs(idPeriodo);
    }

    private getCAs(idPeriodo?: number): void {
        this.CAs = [];
        if (!idPeriodo) {
            this.periodoForUi = null;
            return;
        }
        this.globalCampaniasService.getCAsByPeriodo(idPeriodo).subscribe(res => {
            this.CAs = [...res];
            // Disparamos CaSelected cuando el usuario es CA, porque no se "pinta" el desplegable de CAs en pantalla.
            // de otra forma, nunca se cargarían en pantalla los dependendientes de la CA.
            if (this.isCA && this.CAs.length > 0) {
                const caSelectedViewModel = new CASelectedViewModel();
                let IdCa = 0;
                if (this.isCA) {
                    IdCa = this.loggedInUser?.TwUsuarioCa?.IdCa || 0;
                } else {
                    IdCa = this.payload?.IdCA || 0;
                }
                caSelectedViewModel.idCA = this.CAs.filter(ca => ca.IdCa === IdCa)?.at(0)?.IdCa || 0; // Si el usuario es CA, solo tendrá 1 CA en el desplegable.
                caSelectedViewModel.idPeriodo = idPeriodo;
                this.onCASelected(caSelectedViewModel);
            }
        });
    }

    onCASelected(param$: CASelectedViewModel): void {
        this.EAs = [];
        this.getProvincias(param$);
        this.onProvinciaSelected(this.payload?.IdProvincia || 0);

        if (!param$.idPeriodo || !param$.idCA) {
            return;
        }

        this.globalCampaniasService.getEAsByCA(param$).subscribe(res => {
            this.EAs = res;
        });
    }

    private getProvincias(param$: CASelectedViewModel): void {
        const promiseAmbitoNacional = () => {
            return new Promise(resolve => {
                if (!this.periodos || this.periodos.length === 0) {
                    // @author: scalero1 - Al obtener el periodo, tendremos que traernos tb la propiedad que indica si es de ámbito nacional
                    if (param$?.idPeriodo === this.periodoForUi?.Id) {
                        resolve(this.periodoForUi?.AmbitoNacional);
                        return;
                    }
                    // No debería pasar por aquí, pues el periodo ya debería estar descargado al seleccionarlo.
                    // No obstante, dejamos ésta llamada.
                    this.periodoCamService
                        .getById(param$.idPeriodo!)
                        .pipe(
                            tap((p: PeriodoCamViewModel) => {
                                resolve(p?.AmbitoNacional);
                            }),
                            catchError(() => {
                                resolve(false);
                                return of(false);
                            }),
                        )
                        .subscribe();
                } else {
                    const ambitoNacional = this.periodos.find(x => x.Id === param$.idPeriodo)?.AmbitoNacional || false;
                    resolve(ambitoNacional);
                }
            });
        };

        promiseAmbitoNacional().then((res: any) => {
            if (!this.filtroBase) {
                this.filtroBase = new TwSolicitudCamViewModelBase();
            }
            this.filtroBase.AmbitoNacional = res;
            this.filtroBase.IdCa = param$.idCA!;
            this.filtroBase.IdPeriodoCam = param$.idPeriodo!;

            this.loadProvincias();
        });
    }

    getOperadores(tipoSolicitudSelected: boolean): void {
        if (!tipoSolicitudSelected) {
            this.operadores = [];
            return;
        }
        const formModel = { ...this.form.getRawValue() } as FilterSearchingRecintoUnidadInspeccion;

        const finalModel = {
            IdCampania: formModel.IdCampania,
            IdPeriodo: formModel.IdPeriodo,
            IdCA: formModel.IdCA,
            IdEntidadAuditora: formModel.IdEntidadAuditora || null,
            IdTipoSolicitudCam: formModel.IdTipoSolicitudCam,
        };

        this.buscadorUnidadInspeccionService.getRecintoUIOperadores(finalModel).subscribe(res => {
            this.operadores = res;
        });
    }

    /**
     * Respond to the action of searching on "selector-unidad-inspeccion-filter".
     * It will send the filter to the backend and set the response.
     * If the search comes from the "filter" component, the fields related to the pagination will be reset.
     * In the search comes from the "list-paginator" component case the search params remain the same.
     * @param payload FilterSearchingRecintoUnidadInspeccion
     * @return void
     */
    onSearch(payload: FilterSearchingRecintoUnidadInspeccion): void {
        if (!this.editMode) {
            this.navMenuService.clearMenuServiceForUdInspeccion();
        }

        if (!equalObjects(this.payload, payload)) {
            // As soon as the user changes the "filter", the previous payload pagination values have no sense
            // When recovering the request params from the last result, the pagination params won't be reset.
            payload = this.clearPaginationFilter(payload);
        }

        this.payload = { ...payload } as FilterSearchingRecintoUnidadInspeccion; // To keep a copy to be used in the lazy search (paginator)
        if (!payload) {
            return;
        }

        this.payload.Autorizado = EnumSiNoTodos.SI;
        this.payload.CodigoUhc = ''; // Nos interesa cualquier recinto disponible. Los que no están disponibles tendrán un código UHC asignado.
        this.payload.IdEstadoUnidadInspeccion = EnumIdsTcEstadoUnidadInspeccion.ID_SIN_ASIGNAR; // Nos interesan los que estén disponibles

        if (this.payload.IdTipoSolicitudCam === null) {
            this.payload.IdTipoSolicitudCam = -1; // Así forzamos a que (en el core) se excluyan del resultado los almacenes y las empresas deshid.
        }
        this.searching = true;

        this.buscadorUnidadInspeccionService
            .getRecintoUnidadesInspeccion(this.payload)
            .pipe(
                tap(results => {
                    this.result = results as RecintoUnidadInspeccionItemResultsViewModel;
                    if (!this.result || (this.result?.ResultList?.length === 0 && this.numberOfChanges === 0)) {
                        // Si la búsqueda actual no ha devuelto resultados, permitimos de nuevo al usuario realizar otra búsqueda distinta: habilitamos el formulario criteria
                        this.enableFormCriteria();
                    }
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    private disableFormCriteria(): void {
        if (this.editMode) {
            return;
        }
        this.formGroup.controls['IdCampania'].disable();
        this.formGroup.controls['IdPeriodo'].disable();
        this.formGroup.controls['IdCA'].disable();
        this.formGroup.controls['IdEntidadAuditora'].disable();
        this.formGroup.controls['IdTipoSolicitudCam'].disable();
        this.formGroup.controls['IdOperador'].disable();
        this.formGroup.markAsDirty();
    }

    /**
     * En modo edición no se permite volver a buscar.
     * @returns void
     */
    private enableFormCriteria(): void {
        if (this.editMode) {
            return;
        }
        this.formGroup.controls['IdCampania'].enable();
        this.formGroup.controls['IdPeriodo'].enable();
        this.formGroup.controls['IdCA'].enable();
        this.formGroup.controls['IdEntidadAuditora'].enable();
        this.formGroup.controls['IdTipoSolicitudCam'].enable();
        this.formGroup.controls['IdOperador'].enable();
    }

    /**
     * We don't clear the whole filter but only the fields related to the pagination.
     */
    private clearPaginationFilter(payload: FilterSearchingRecintoUnidadInspeccion): FilterSearchingRecintoUnidadInspeccion {
        if (!payload) {
            return payload;
        }
        payload.PageNumber = 0;
        payload.Asc = 0;
        payload.OrderBy = '';
        return payload;
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        this.payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingRecintoUnidadInspeccion;
        this.onSearch(this.payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onReset(): void {
        this.searching = false;
        this.result = null;
        this.totalHectareasAcumuladas = 0;
        this.numberOfChanges = 0;

        if (!this.editMode) {
            this.enableFormCriteria();
            const cleanDependent = true;
            this.onActivaSelected(cleanDependent);
            this.cleanUnidadInspeccion();
            this.navMenuService.clearMenuServiceForUdInspeccion();
        }
    }

    private cleanUnidadInspeccion(): void {
        this.unidadInspeccionPayload.RecintoUnidadInspeccionListIds = [];
    }

    private cleanDependentOnActiva(): void {
        if (this.payload) {
            this.payload.IdCampania = 0;
        }

        this.cleanDependentOnCampania();
    }

    private cleanDependentOnCampania(): void {
        if (this.payload) {
            this.payload.IdPeriodo = 0;
            this.payload.IdCA = 0;
            this.payload.IdEntidadAuditora = 0;
            this.payload.IdOperador = 0;
            this.payload.IdTipoSolicitudCam = 0;
        }
    }

    /**
     * Redirigimos al formulario de detalle de la UI o al del listado de UIs, según de donde provenga.
     * @return void
     */
    onBack(id: number): void {
        if (id) {
            this.router.navigate(['/campanias/unidadinspeccion/datosbasicos/detail/' + id]);
        } else {
            this.router.navigate([this.listUrl]);
        }
    }

    /**
     * This method is executed after selecting Cultivos in the dialog.
     * @param selectedRecintosCultivos RecintoUnidadInspeccionItemViewModel[]
     * @returns void
     */
    onSelectedRecintosUI(selectedRecintosCultivos: RecintoUnidadInspeccionItemViewModel[]): void {
        // En cada selección, como recibimos un array con los elementos seleccionados, volvemos a empezar a calcular de nuevo.
        this.recintoUnidadInspeccionList = [...this.recintosUIOriginales];
        this.calcularHectareasAcumuladas();

        if (selectedRecintosCultivos?.length === 0) {
            this.numberOfChanges = 0;
            this.enableFormCriteria();
        } else {
            this.disableFormCriteria();
        }

        selectedRecintosCultivos?.forEach(selectedRecintoCultivos => {
            this.addRecintoUI(selectedRecintoCultivos);
        });
    }

    private calcularHectareasAcumuladas(): void {
        this.totalHectareasAcumuladas = 0;
        this.recintoUnidadInspeccionList?.forEach(recintoUI => {
            this.totalHectareasAcumuladas += recintoUI.Cultivo?.SuperficieVariedad;
        });
    }

    /**
     * Este método intenta añadir el recinto-UI seleccionado a la lista ya existente de recintos-UI.
     * Si el recinto-UI no existía se añade entero con todos sus cultivos seleccionados y se contabilizan las HAs de los cultivos, para comprobar que no superen las HAs definidas para el periodo.
     * Si el recinto ya existía, muestra mensaje por pantalla indicando que ha encontrado un recinto-UI coincidente.
     * @param recintoCultivosSelected RecintoUnidadInspeccionItemViewModel
     * @returns void
     */
    private addRecintoUI(recintoCultivosSelected: RecintoUnidadInspeccionItemViewModel): void {
        if (!recintoCultivosSelected || !recintoCultivosSelected.Cultivo) {
            return;
        }
        const recintoUI: RecintoUnidadInspeccionItemViewModel | undefined = this.recintoUnidadInspeccionList?.find(
            item => item.Id === recintoCultivosSelected.Id,
        ); // Primero buscamos el recinto entre los ya añadidos
        if (recintoUI) {
            // No debería darse el caso, porque los recintos disponibles no están asociados a ninguna UI. Pero se controla igualmente.
            this.addWarningMessage(this.WarningMessageRecintosDuplicados + ' en el SigPac ' + this.getSigpac(recintoUI));
            return;
        }

        if (!this.recintoUnidadInspeccionList) {
            // No debería entrar aquí, porque estamos en modo edición, y ya tendría que existir algún recinto en la UI
            this.recintoUnidadInspeccionList = [];
        }
        this.recintoUnidadInspeccionList.push(recintoCultivosSelected);
        this.numberOfChanges++;

        // Ahora contabilizamos las HAs del cultivo del recinto-UI, para controlar que no superen las configuradas para el periodo.
        if (this.periodoForUi?.SuperficieMax) {
            this.totalHectareasAcumuladas += recintoCultivosSelected.Cultivo.SuperficieVariedad;
            if (this.totalHectareasAcumuladas > this.periodoForUi!.SuperficieMax!) {
                this.addErrorMessage(this.errorSuperficieSuperadaMessage + this.totalHectareasAcumuladas + ' ha');
            }
        }
    }

    /**
     * Se captura el evento que indica que la ventana de diálogo que muestra el detalle del recinto
     * se ha cerrado.
     * @param $event any
     */
    onRecintoDialogClosed($event: any): void {
        this.recintoDetailVisible = false;
    }

    /**
     * Se mostrará una ventana popup con el detalle del recinto, del almacén o de la empresa deshidratadora, según correponda.
     * @param itemId RecintoUnidadInspeccionItemViewModel
     * @return void
     */
    onView(item: RecintoUnidadInspeccionItemViewModel): void {
        if (item.IdTipoSolicitudCam === EnumIdsTcTipoSolicitudCam.ID_INVERNADERO || item.IdTipoSolicitudCam === EnumIdsTcTipoSolicitudCam.ID_PARCELA) {
            // Abrir detalle recinto PI
            this.IdRecintoSelected = item.Cultivo.IdRecinto;
            this.recintoDetailVisible = true;
        }
    }

    onClickSave(): void {
        if (!this.recintoUnidadInspeccionList || this.recintoUnidadInspeccionList.length === 0) {
            console.error('NO se han seleccionado recintos-UI');
            return;
        }
        this.unidadInspeccionPayload.IdUsuario = this.userData.idUsuario;
        if (this.editMode) {
            this.unidadInspeccionPayload.IdUi = this.unidadInspeccion?.IdUi;
        }
        this.unidadInspeccionPayload.RecintoUnidadInspeccionListIds = this.convertRecintosSolicitud(this.recintoUnidadInspeccionList);

        this.visibilitySpinnerSave = true;
        this.unidadInspeccionService
            .insertOrUpdateUI(this.unidadInspeccionPayload)
            .pipe(
                tap(idUi => {
                    this.visibilitySpinnerSave = false;
                    this.addSuccessMessage(this.successMessage);
                    this.onBack(idUi); // En caso de edición llevará al mismo que hay en unidadInspeccion.IdUi, o el capturado de la URL.
                }),
                catchError(error => {
                    this.visibilitySpinnerSave = false;
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * Obtenemos la lista de Ids de recintos-UI añadidos a la UI.
     * @param recintosCultivos RecintoUnidadInspeccionItemViewModel[]
     * @returns number[]
     */
    private convertRecintosSolicitud(recintosCultivos: RecintoUnidadInspeccionItemViewModel[]): number[] {
        const recintosCultivosToBeSaved: number[] = [];
        recintosCultivos?.forEach(recintoCultivo => {
            if (recintoCultivo.IdUi === null) {
                // Son los que no están vinculados a una UI los que guardamos
                recintosCultivosToBeSaved.push(recintoCultivo.Id); // Id del recinto-ui
            }
        });
        return recintosCultivosToBeSaved;
    }

    get formInvalid(): boolean {
        return !this.form.valid || !this.form.dirty || this.form.pristine;
    }

    get allowSaving(): boolean {
        const idTipoSolicitudCam = this.getIdTipoSolicitudCam();

        if (!idTipoSolicitudCam) {
            return false;
        }

        const hasAccess =
            this.loggedInUser?.getAction(EnumCodigosTwTcAcciones.ADD_RECINTO_UD_INSPECCION, this.unidadInspeccion?.IdEstadoUi, idTipoSolicitudCam).Editable ||
            false;
        return hasAccess;
    }

    private getIdTipoSolicitudCam(): number | undefined {
        let idTipoSolicitudCam = undefined;
        if (this.unidadInspeccion?.FirstRecinto) {
            idTipoSolicitudCam = this.unidadInspeccion.FirstRecinto?.IdTipoSolicitudCam;
        } else {
            idTipoSolicitudCam = this.formGroup.controls['IdTipoSolicitudCam'].value;
        }

        return idTipoSolicitudCam;
    }

    get allowCreating(): boolean {
        const hasAccess = this.loggedInUser?.getAction(EnumCodigosTwTcAcciones.NUEVA_UD_INSPECCION).Editable || false;
        return hasAccess;
    }

    private get readonly(): boolean {
        return this.editMode && this.unidadInspeccion?.FirstRecinto ? this.unidadInspeccion?.FirstRecinto.PeriodoEnPlazoVigente === false : false;
    }

    get title(): any {
        if (!this.unidadInspeccion)
            return { plural: EnumDescripcionTcTipoSolicitudCamPlural.RECINTOS, singular: EnumDescripcionTcTipoSolicitudCamSingular.RECINTO };

        const idTipoSolicitudCam = this.getIdTipoSolicitudCam();
        switch (idTipoSolicitudCam) {
            case EnumIdsTcTipoSolicitudCam.ID_CONFECCION:
                return { plural: EnumDescripcionTcTipoSolicitudCamPlural.CONFECCION, singular: EnumDescripcionTcTipoSolicitudCamSingular.CONFECCION };
            case EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION:
                return {
                    plural: EnumDescripcionTcTipoSolicitudCamPlural.EMPRESA_DESHIDRATACION,
                    singular: EnumDescripcionTcTipoSolicitudCamSingular.EMPRESA_DESHIDRATACION,
                };
            case EnumIdsTcTipoSolicitudCam.ID_PARCELA:
                return {
                    plural: EnumDescripcionTcTipoSolicitudCamPlural.PARCELA,
                    singular: EnumDescripcionTcTipoSolicitudCamSingular.PARCELA,
                };
            case EnumIdsTcTipoSolicitudCam.ID_INVERNADERO:
                return {
                    plural: EnumDescripcionTcTipoSolicitudCamPlural.INVERNADERO,
                    singular: EnumDescripcionTcTipoSolicitudCamSingular.INVERNADERO,
                };
            default:
                return { plural: EnumDescripcionTcTipoSolicitudCamPlural.RECINTOS, singular: EnumDescripcionTcTipoSolicitudCamSingular.RECINTO };
        }
    }

    get titleButtonSave(): string {
        return this.editMode ? 'Guardar Ud. Inspección' : 'Crear Ud. Inspección';
    }

    private get allowToAdd(): boolean {
        return (this.allowCreating || this.allowSaving || this.periodoForUi?.HabilitadaTemporalmente === true) && !this.superficieAcumuladaExcedida;
    }

    get disableSavingButton(): boolean {
        return this.formInvalid || this.numberOfChanges === 0 || this.readonly || !this.allowToAdd || this.visibilitySpinnerSave;
    }

    get superficieAcumuladaExcedida(): boolean {
        if (!this.periodoForUi?.TamanioMaximoAgrupacion) {
            return false;
        }
        if (!this.periodoForUi?.SuperficieMax) {
            return false;
        }

        return this.totalHectareasAcumuladas > this.periodoForUi?.SuperficieMax;
    }

    get idTipoSolicitudCam(): number {
        if (this.unidadInspeccion?.FirstRecinto?.IdTipoSolicitudCam) {
            return this.unidadInspeccion.FirstRecinto.IdTipoSolicitudCam;
        }
        if (!this.editMode) {
            const formModel = { ...this.form.getRawValue() } as FilterSearchingRecintoUnidadInspeccion;
            return formModel?.IdTipoSolicitudCam as number;
        }
        return 0;
    }

    private getSigpac(recintoUI: RecintoUnidadInspeccionItemViewModel): string {
        return (
            recintoUI.Cultivo.Recinto.IdProvincia +
            ':' +
            recintoUI.Cultivo.Recinto.IdMunicipioSigPac +
            ':' +
            recintoUI.Cultivo.Recinto.Agregado +
            ':' +
            recintoUI.Cultivo.Recinto.Zona +
            ':' +
            recintoUI.Cultivo.Recinto.Poligono +
            ':' +
            recintoUI.Cultivo.Recinto.Parcela +
            ':' +
            recintoUI.Cultivo.Recinto.Recinto
        );
    }

    ngOnDestroy(): void {
        // En éste componente se utiliza el mismo servicio que en la búsqueda de uds. de inspección.
        // Como se sobreescribe el payload en las búsquedas aquí realizadas, restauramos el que había,
        // así, al volver al buscador, tendremos la misma búsqueda.
        this.buscadorUnidadInspeccionService.setLastSearch(this.previousPayload!);
    }
}
